import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="page">
      <div id="privacy-policy">
        <h1>Privacy Policy</h1>
        <p>
          Migdaley Medical Care Ltd., Company No. 512026527, located at 13 Aba
          Berdichev Street, Bat Yam (the "Operator"), respects and protects the
          privacy of every person who uses the InHeal application (the "User" or
          "Users", and the "Application", respectively), operated by it.
        </p>
        <p>
          The Application enables users to participate in body-mind-spirit
          programs and workshops, view therapeutic and digital content, document
          personal experiences and feelings, complete personal or professional
          questionnaires related to feelings, emotional states, or physical
          indicators as part of matching or follow-up processes, receive
          reminders and self-practice tools, communicate with certified guides
          or therapists on behalf of the Operator, and track their progress
          within treatment, empowerment, or resilience processes (the
          "Services").
        </p>
        <p>
          This Privacy Policy is an integral part of the Operator's legal
          framework, including the Application Terms of Use and any other
          document governing the use of the Application and the relationship
          between Users and the Operator.
        </p>
        <p>
          This Policy is available in the Application and in the Operator's
          official channels, and its purpose is to clarify what information is
          collected, for what purposes it is collected, how it is used, under
          what circumstances it may be shared with third parties, and how it is
          stored and protected.
        </p>
        <p>
          Information provided by Users or collected during the use of the
          Application is stored in databases owned by the Operator, as detailed
          in Section 14 below, and solely for the purposes set out in this
          Policy. The User declares and undertakes that all information provided
          through the Application is true, reliable, and accurate, and is
          provided in their own name and on their own behalf, and not on behalf
          of third parties, unless lawful and explicit authorization was given.
        </p>
        <p>
          Providing information to the Operator is voluntary and based on the
          User's full consent and is not required by law. However, failure to
          provide required information may prevent the Operator from providing
          all or part of the Services, including participation in workshops,
          receiving treatments, using the Application, or receiving materials
          through it.
        </p>
        <p>
          Use of the Application, including registration for Services, filling
          out questionnaires, creating a user profile, receiving content,
          receiving reminders or notifications, documenting personal feelings, or
          any other action performed through the Application (the "Use"),
          constitutes the User's approval and consent to this Privacy Policy and
          its terms.
        </p>
        <p>
          If you do not agree with this Policy or any part of it, please refrain
          from using the Application. If you wish to receive information or
          services through an alternative method, you may contact the Operator
          as detailed in Section 14 below, and the Operator will make reasonable
          efforts to assist through alternative means, where possible.
        </p>
        <p>
          This Privacy Policy is written in the masculine form for convenience
          only and applies equally to all genders.
        </p>

        <h2>1. What Is "Information"</h2>
        <p>
          In this Privacy Policy, the term "Information" has the meaning of
          "Personal Information" under the Israeli Protection of Privacy Law,
          1981, and includes any information collected by the Operator or
          provided to it by the User or on the User's behalf as part of
          receiving the Services.
        </p>

        <h2>2. Sources Through Which the Operator Collects Information</h2>
        <p>
          As part of using the Application and receiving Services through it, the
          Operator may collect information about Users from various sources,
          including:
        </p>
        <p>
          2.1 Information provided by the User: information actively submitted
          in the Application, including during registration, account creation,
          completion of personal, emotional, functional, or health
          questionnaires, self-assessment forms, declarations or informed
          consent forms, and freely entered information such as feelings,
          thoughts, personal experience records, emotional descriptions, or
          insights as part of using the Services.
        </p>
        <p>
          2.2 Information generated during use of the Application and/or
          Services: technical and content-related data generated from how the
          User interacts with the Application and Services, including connection
          and technology identifiers (such as device type, operating system, IP
          address, usage times, and activity frequency), interactions with
          content, content viewing, questionnaire responses, exercises, and
          participation in programs.
        </p>
        <p>
          2.3 Information from third parties: subject to explicit User consent
          and where required for service delivery, the Operator may receive
          additional information from third parties involved in operating the
          Application, such as guides, certified therapists, technology service
          providers, and additional parties assisting with service operation,
          solely for service purposes and in accordance with applicable law.
        </p>

        <h2>3. Information the Operator Collects About Users</h2>
        <p>
          As part of using the Application and providing Services, the Operator
          collects, stores, and processes information provided by Users or
          generated while receiving Services, including all or part of the
          following:
        </p>
        <p>
          3.1 Identification and contact details: name, identification number,
          date of birth, and contact details (phone, mobile phone, and address).
        </p>
        <p>
          3.2 Emotional, functional, or medical information: sensitive
          information provided by the User or generated while using Services for
          personal program matching, progress tracking, and professional support.
        </p>
        <p>
          3.3 Information generated during use of the Application:
          questionnaire/exercise results, usage patterns, login/activity times,
          engagement/progress indicators, submitted feedback, and automated
          insights derived from usage.
        </p>
        <p>
          3.4 Communication information: information related to correspondence
          or interactions between the User and guides, certified therapists, or
          Operator representatives, including forms, chat, in-app messages, and
          support records.
        </p>
        <p>
          3.5 Technical and operational information: technical data collected
          automatically, such as device type, operating system, app version, IP
          address, device ID, interface language, general location (if
          permission is enabled), performance data, and failures.
        </p>
        <p>
          3.6 Information voluntarily provided by the User: any additional
          information the User provides through free text, feedback, or
          communication with Operator representatives, as relevant for service
          operation and support.
        </p>

        <h2>4. Purposes for Which the Operator Collects Information</h2>
        <p>
          The Operator collects User information for service provision and for
          one or more of the following purposes:
        </p>
        <p>
          4.1 To provide Services through the Application, including operating
          digital programs, exercises, educational content, personal/group
          guidance, and handling user requests.
        </p>
        <p>
          4.2 To personalize user experience, content, and recommendations in
          the Application according to User characteristics, needs, or
          preferences.
        </p>
        <p>
          4.3 To monitor User progress in programs and exercises, generate
          personal/general insights, and provide personalized feedback.
        </p>
        <p>
          4.4 To analyze usage patterns, performance, and engagement metrics for
          service improvement, development of new tools/interfaces, and deeper
          understanding of user experience.
        </p>
        <p>
          4.5 To operate, secure, monitor, and technically support digital
          services, including fault detection and service continuity.
        </p>
        <p>
          4.6 To maintain contact with Users, including system notifications,
          service updates, ongoing activity offers, or professional information,
          subject to consent and applicable law.
        </p>
        <p>4.7 To contact Users regarding the Services and related updates.</p>
        <p>4.8 To conduct analysis, research, and statistical activities.</p>
        <p>
          4.9 To display and tailor advertisements that may match User
          preferences, whether on the Operator's platforms or third-party
          advertising platforms/websites.
        </p>
        <p>4.10.</p>
        <p>
          4.11 To defend against claims, demands, and allegations against the
          Operator, its representatives, or third parties.
        </p>
        <p>4.12 To enforce the terms of this Privacy Policy.</p>
        <p>4.13 To comply with legal requirements.</p>

        <h2>5. Transfer of Information</h2>
        <p>
          5.1 The Operator will not transfer or disclose information to third
          parties except as stated in this Privacy Policy.
        </p>
        <p>
          5.2 Any transfer will include only relevant information required for a
          defined, explicit, and legitimate purpose and in a proportionate
          manner.
        </p>
        <p>
          5.3 The Operator may transfer information, in whole or in part, in one
          or more of the following cases:
        </p>
        <p>
          5.3.1 For service delivery through the Application, including
          transferring relevant information to guides, certified therapists, or
          professional service providers acting on behalf of the Operator.
        </p>
        <p>
          5.3.2 To third parties providing services to the Operator, including
          IT/security support, storage, app/web development, survey/research,
          marketing/advertising, legal services, online meetings, and external
          advisors.
        </p>
        <p>
          5.3.3 If the Operator receives a lawful order, including a court order,
          requiring disclosure.
        </p>
        <p>
          5.3.4 In any dispute, claim, demand, lawsuit, or legal proceeding
          between the User (or anyone on their behalf) and the Operator (or
          anyone on its behalf).
        </p>
        <p>
          5.3.5 In connection with transfer, assignment, sale, purchase, merger,
          or change of control of the Operator or its assets, whether fully or
          partially, with or without consideration, including feasibility checks.
        </p>
        <p>
          5.3.6 If a claim is raised, or suspicion arises, that a User has
          performed an act/omission that may harm the Operator, its
          representatives, third parties, or other Users.
        </p>
        <p>
          5.3.7 In any case where the Operator believes disclosure is necessary
          to prevent harm to the Operator, a User, or a third party.
        </p>

        <h2>6. Information Security</h2>
        <p>
          The Operator applies technical and physical privacy/information
          security measures according to accepted standards. However, storage and
          transmission of information electronically, including over the
          Internet, can never be fully secure. By providing information, Users
          acknowledge and accept these risks. The Operator does not guarantee
          complete immunity of its databases from unauthorized access. In any
          case, if a User has reason to believe that transferring information to
          the Operator is no longer secure, please update us using the contact
          method listed in Section 14 of this Privacy Policy.
        </p>

        <h2>7. Limitation of Liability</h2>
        <p>
          The Operator and anyone on its behalf shall not bear liability and are
          exempt from responsibility for any loss, damage, or expense of any
          kind, whether direct or indirect, incidental or consequential, in
          connection with information collection, use, transfer, storage,
          security, and related activities.
        </p>

        <h2>8. Data Retention Period</h2>
        <p>
          The Operator will retain User information for the period necessary to
          fulfill the purposes detailed in this Policy, unless a longer period
          is required or permitted by law.
        </p>

        <h2>9. Information About Other People</h2>
        <p>
          If a User provides personal information about other people (including
          family members, acquaintances, friends, or additional third parties),
          they may do so only after informing those parties about this Policy
          and obtaining any consent required by law.
        </p>

        <h2>10. Non-Identifiable Information</h2>
        <p>
          The Application uses cookies and similar technologies for one or more
          of the purposes listed in this Policy. Additional details are available
          in the Cookies Policy available in the Application.
        </p>

        <h2>11. Right to Access and Correct Information</h2>
        <p>
          11.1 The right to access and correct personal information is governed
          by Sections 13 and 14 of the Israeli Protection of Privacy Law. Users
          may submit requests by contacting the Operator according to the
          contact details listed in Section 14 of this Privacy Policy below.
        </p>

        <h2>12. Links and Hyperlinks</h2>
        <p>
          12.1 The Application may include links, hyperlinks, or banners to
          other websites that the Company does not supervise or review,
          including their reliability, legality, security, and privacy policies.
        </p>
        <p>
          12.2 The Company is not responsible for Users' use of links appearing
          in the Application, pages outside the Application, or other websites,
          and Users undertake to comply with the terms and conditions of such
          websites or web pages and to contact the providers of those websites
          or pages directly regarding issues related to entry, browsing, use,
          and more.
        </p>
        <p>
          12.3 Therefore, the Company bears no responsibility of any kind in
          connection with other websites, including in relation to collection,
          use, and transfer of information on those websites and the content
          published on those pages.
        </p>

        <h2>13. Governing Law and Jurisdiction</h2>
        <p>
          13.1 This Privacy Policy and any amendment, as well as use of the
          Application, are governed by the laws of the State of Israel.
        </p>
        <p>
          13.2 The Operator's actions regarding information collection,
          processing, use, storage, and transfer shall be in accordance with this
          Policy and applicable law.
        </p>
        <p>
          13.3 Jurisdiction in connection with any dispute and/or claim arising
          in connection with use of the website and this Privacy Policy, or
          related to them, is exclusively vested in the courts of Tel Aviv-Yafo,
          Israel.
        </p>

        <h2>14. Changes and Updates</h2>
        <p>
          The Operator may update this Privacy Policy from time to time at its
          sole discretion, without prior notice. The updated version published in
          the website will bind the User, as applicable. Continued receipt of the
          Operator's services, or requesting its services, after a Privacy Policy
          update constitutes the User's consent, as applicable, to the updated
          Privacy Policy, including its changes.
        </p>

        <h2>15. Miscellaneous</h2>
        <p>
          15.1 This Policy shall be interpreted and implemented subject to
          applicable law. In case of contradiction, legal provisions prevail.
        </p>
        <p>
          15.2 Users may not assign their rights/obligations under this Policy.
          The Operator may transfer its rights/obligations.
        </p>
        <p>
          15.3 Nothing in this Policy derogates from any right granted to the
          Operator and/or anyone on its behalf under applicable law.
        </p>

        <h2>16. Contact</h2>
        <p>
          16.1 For questions or comments regarding this Privacy Policy, please
          contact the Operator by email at: info@imfa.co.il
        </p>
        <p>Updated as of November 2025.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
